import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
/* eslint-disable @typescript-eslint/no-explicit-any */

import React from 'react';
import deepEqual from 'deep-equal';
export const SitecoreContextReactContext = /*#__PURE__*/React.createContext({});
export const ComponentFactoryReactContext = /*#__PURE__*/React.createContext({});
export let SitecoreContext = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SitecoreContext, _React$Component);

  function SitecoreContext(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.setContext = value => {
      if (deepEqual(value, _this.state.context)) return;

      _this.setState({
        context: value
      });
    };

    let context = {
      pageEditing: false
    };

    if (props.context) {
      context = props.context;
    }

    if (props.context === null) {
      context = null;
    }

    _this.state = {
      context,
      setContext: _this.setContext
    };
    return _this;
  }

  var _proto = SitecoreContext.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!deepEqual(prevProps.context, this.props.context)) {
      this.setState({
        context: this.props.context
      });
      return;
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(ComponentFactoryReactContext.Provider, {
      value: this.props.componentFactory
    }, /*#__PURE__*/React.createElement(SitecoreContextReactContext.Provider, {
      value: this.state
    }, this.props.children));
  };

  return SitecoreContext;
}(React.Component);
SitecoreContext.displayName = 'SitecoreContext';